// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\PierGroup\ApiPierGroup.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';
import { Port, PortData, PortOptions } from 'data/models/Port';

// PierGroupData is the class that PierGroup serializes to/from
export interface PierGroupData {
    Id : number;
    Url : string | null;
	
    Berths : BerthData[] | null;
    Port : PortData | null;
    PortId : number;
	
    AgentChangeWindowHours : number | null;
    EndOverhang : MeasurementData;
    Length : MeasurementData;
    Order : number;
    PreventAgentOverlaps : boolean;
    RequireKnownVessels : boolean;
    StartOverhang : MeasurementData;
}

// PierGroupOptions is the class which may be passed to the PierGroup constructor to define optional initial data values
export interface PierGroupOptions {
    Id : number;
    Url? : string | null;
	
    Berths? : BerthOptions[] | null;
    Port? : PortOptions | null;
    PortId? : number;
	
    AgentChangeWindowHours? : number | null;
    EndOverhang? : MeasurementOptions;
    Length? : MeasurementOptions;
    Order? : number;
    PreventAgentOverlaps? : boolean;
    RequireKnownVessels? : boolean;
    StartOverhang? : MeasurementOptions;
}

export class PierGroup {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Berths : SDataArray<Berth>;
    public Port : DataSignal<Port | null>;
    public PortId : DataSignal<number>;
	
    public AgentChangeWindowHours : DataSignal<number | null>;
    public EndOverhang : Measurement;
    public Length : Measurement;
    public Order : DataSignal<number>;
    public PreventAgentOverlaps : DataSignal<boolean>;
    public RequireKnownVessels : DataSignal<boolean>;
    public StartOverhang : Measurement;

    constructor();
    constructor(data : PierGroupOptions);
    constructor(data: PierGroupOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Berths = SArray<Berth>([]);
        this.Port = S.value<Port | null>(null);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
        this.AgentChangeWindowHours = jsonableObservable(S.value<number | null>(data && data.AgentChangeWindowHours !== undefined ? data.AgentChangeWindowHours : null));
        this.EndOverhang = data && data.EndOverhang !== undefined ? new Measurement(data.EndOverhang) : new Measurement();
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
        this.PreventAgentOverlaps = jsonableObservable(S.value<boolean>(data && data.PreventAgentOverlaps !== undefined ? data.PreventAgentOverlaps : false));
        this.RequireKnownVessels = jsonableObservable(S.value<boolean>(data && data.RequireKnownVessels !== undefined ? data.RequireKnownVessels : false));
        this.StartOverhang = data && data.StartOverhang !== undefined ? new Measurement(data.StartOverhang) : new Measurement();
    }

    static key(obj : PierGroup) {
        return obj.Id();
    }
    
    static dataKey(obj : PierGroupOptions) {
        return obj.Id;
    }

    static update(obj : PierGroup, data : PierGroupOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
            if (data.AgentChangeWindowHours !== undefined) obj.AgentChangeWindowHours(data.AgentChangeWindowHours);
            if (data.EndOverhang !== undefined) Measurement.update(obj.EndOverhang, data.EndOverhang);
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.Order !== undefined) obj.Order(data.Order);
            if (data.PreventAgentOverlaps !== undefined) obj.PreventAgentOverlaps(data.PreventAgentOverlaps);
            if (data.RequireKnownVessels !== undefined) obj.RequireKnownVessels(data.RequireKnownVessels);
            if (data.StartOverhang !== undefined) Measurement.update(obj.StartOverhang, data.StartOverhang);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PierGroup.ts